<template>
  <div class="LEADS-PAUSE">
    <button
        class="BUTTON btn"
        :class="activeState"
        @click.prevent="isActiveModalOpen = true">
      <div class="CIRCLE"></div>
      <span>{{ activeLabel }}</span>
    </button>
    <active-leads-modal
        v-if="isActiveModalOpen"
        @close="onActiveModalClose"
        @pause="onLeadsPause"
        :active-message="activeMessage"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isWithinInterval, startOfDay, endOfDay, parseISO } from 'date-fns';
import ActiveLeadsModal from '@/views/Dashboard/components/ActiveLeadsModal';

export default {
  name: 'leads-pause',
  components: {
    ActiveLeadsModal,
  },
  data () {
    return {
      isActiveModalOpen: false,
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
      'unavailabilities',
      'occupationUnavailabilities',
      'occupationNames',
    ]),
    activeState () {
      switch (true) {
        case this.isAllPausedToday === true:
        case this.activeOccupations.length === 0:
          return 'NONE';
        case this.activeOccupations.length < this.occupationNames.length:
          return 'SOME';
        default:
          return 'ALL';
      }
    },
    activeLabel () {
      switch (this.activeState) {
        case 'NONE':
          return '0 Active';
        case 'SOME':
          return `${this.activeOccupations.length} Active`;
        default:
          return 'All Active';
      }
    },

    activeMessage () {
      switch (this.activeState) {
        case 'NONE':
          return 'You are currently receiving leads for No Occupations.';
        case 'SOME':
          return `You are currently receiving leads for ${this.listOccupations}.`;
        default:
          return 'You are currently receiving leads for All Occupations.';
      }
    },
    activeOccupations () {
      return this.occupationNames.filter((occupation) => {
        return !this.pausedOccupations.includes(occupation);
      });
    },
    pausedOccupations () {
      if (this.occupationUnavailabilities) {
        const allPaused = this.occupationUnavailabilities.filter((unavailability) => {
          return isWithinInterval(new Date(), {
            start: startOfDay(new Date(parseISO(unavailability.startDate))),
            end: endOfDay(new Date(parseISO(unavailability.endDate))),
          });
        })
          .map((match) => {
            return this.serviceProviderCatalogOccupations[
              match.serviceProviderOccupationId
            ].occupation.display_name;
          });
        return allPaused;
      }
    },
    isAllPausedToday () {
      if (this.unavailabilities) {
        const allPaused = this.unavailabilities.filter((unavailability) => {
          return isWithinInterval(new Date(), {
            start: startOfDay(new Date(parseISO(unavailability.startDate))),
            end: endOfDay(new Date(parseISO(unavailability.endDate))),
          });
        });
        return allPaused.length > 0;
      }
      return false;
    },
    listOccupations () {
      switch (this.activeOccupations.length) {
        case 1:
          return this.activeOccupations[0];
        case 2:
          return this.activeOccupations.join(' and');
        default:
          return `${this.activeOccupations.slice(0, -2).join(', ')}, ${this.activeOccupations.slice(-2).join(' and ')}`;
      }
    },
  },

  async mounted () {
    await this.fetchServiceProviderUnavailabilities();
    await this.fetchServiceProviderOccupationUnavailabilities(
      { service_provider_occupation_ids: Object.keys(this.serviceProviderCatalogOccupations).join(',') }
    );
  },
  methods: {
    ...mapActions('account/pro', [
      'fetchServiceProviderUnavailabilities',
      'fetchServiceProviderOccupationUnavailabilities',
    ]),
    onLeadsPause () {
      this.$emit('pause');
    },
    onActiveModalClose () {
      this.isActiveModalOpen = false;
    },
  },

};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .LEADS-PAUSE {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
  }
  .BUTTON {
    width: auto;
    border-radius: 2*$unit;

    @include text-small;
    display: flex;
    align-items: center;
    height: 3*$unit;
    font-weight: 600;
    padding: $unit/4 $unit;
    background-color: white;
  }
  .ALL {
    color: #389E0D ;
    border: 3px solid #389E0D;
    &:hover {
      color: darken(#389E0D, 5%);
      border-color: darken(#389E0D, 5%);
    }
    .CIRCLE {
      background-color: #389E0D;
      margin-right: 3px;
      @include circle(10px);
    }
  }
  .SOME {
    color: #AD6800 ;
    border: 3px solid #AD6800;
    &:hover {
      color: darken(#AD6800, 5%);
      border-color: darken(#AD6800, 5%);
    }
    .CIRCLE {
      background-color: #AD6800;
      margin-right: 3px;
      @include circle(10px);
    }
  }
  .NONE {
    color: #F5222D ;
    border: 3px solid #F5222D;
    &:hover {
      color: darken(#F5222D, 5%);
      border-color: darken(#F5222D, 5%);
    }
    .CIRCLE {
      @include circle(10px);
      background-color: #F5222D;
      margin-right: 3px;
    }
  }
</style>
